import "./index.css";

export default function Disclaimer() {
  const disclaimerPoints = [
    "This is not a diagnostic tool, and it does not guarantee the accuracy of the result and cannot be independently acted upon.",
    "This risk score and clinical algorithm is a general guideline for physicians. Any additional laboratory investigations, diagnostic imaging, treatment, or patient education related to lifestyle management is at the physician’s or pulmonologist’s discretion.",
    "To ensure the information in the report is up-to-date, accurate, and correct, the doctor shall be consulted to interpret the report.",
    "Apollo Hospitals and its staff do not offer any assurance on the information made available or are liable for any loss or damage as the said report is based on the AI COPD Risk Score without any intervention from their side.",
    "By usage of AI COPD Risk Score, it is deemed that the beneficiary of this service has agreed to get the same done at his own risk and further agrees with this disclaimer without any limitation or any clauses or sub-clauses. ",
    "Its limitations include use in pediatric asthma and patients currently under treatment."
  ];

  return (
    <ul className="disclaimer-list">
      {disclaimerPoints.map((point, index) => (
        <li key={index} className="disclaimer-item">
          {point}
        </li>
      ))}
    </ul>
  );
}
